import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-speedomater',
  templateUrl: './speedomater.component.html',
  styleUrls: ['./speedomater.component.scss']
})
export class SpeedomaterComponent implements OnInit {
  @Input() rate:string;
  rates = ['INS','INS','INS', 'INS', 'SCARSO','SCARSO', 'MEDIO','MEDIO', 'BUONO','BUONO', 'OTTIMO', 'OTTIMO']

  constructor() { }

  ngOnInit(): void {
  }

}
